module.exports = __webpack_public_path__ + "pattern.0a3d5f9791fee92d132689dc5d93fee9.svg";